import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ConnectionState {
  lastErrorTimestamp: number | null;
  errorCount: number;
}

const initialState: ConnectionState = {
  lastErrorTimestamp: null,
  errorCount: 0,
};

export const connectionSlice = createSlice({
  name: "connection",
  initialState,
  reducers: {
    recordConnectionError: (
      state,
      action: PayloadAction<{ timestamp: number }>
    ) => {
      state.lastErrorTimestamp = action.payload.timestamp;
      state.errorCount += 1;
    },
  },
});

export const { recordConnectionError } = connectionSlice.actions;
export default connectionSlice.reducer;
